import React, {useRef} from 'react';
import PropTypes from 'prop-types';
import TaskNumber from '../../Components/TaskNumber';
import {ExecutionStatus} from '../../../../constants/dataEnum';
import Spinner from '../../../../components/Spinner/Spinner';
import {useClickOutside} from '../../../../lib/customHooks';

function TaskConsolidateTips(props) {
  const {number, isHighlighted, runtimeMode, executionStatus, onSelectTask} = props;

  const taskRef = useRef();

  const onClickOutside = () => {
    if (isHighlighted) {
      onSelectTask();
    }
  };

  useClickOutside(taskRef, onClickOutside);

  return (
    <div
      ref={taskRef}
      className={`task ${isHighlighted && 'selected'}`}
      onClick={onSelectTask}
      style={{
        gridTemplateColumns: '32px auto 32px',
      }}
    >
      <TaskNumber number={number} isHighlighted={isHighlighted} />
      <span style={{fontSize: '12px'}}>
        <b>Consolidate Tips</b>
        {' from '}
        <b>Caddy 2</b>
        {' to '}
        <b>Caddy 1</b>
      </span>
      {runtimeMode && executionStatus === ExecutionStatus.EXECUTING && <Spinner />}
      {runtimeMode && executionStatus === ExecutionStatus.EXECUTED && (
        <img className="executed" src="./svg/protocol-editor/execution-done.svg" alt="Executed" />
      )}
    </div>
  );
}

TaskConsolidateTips.propTypes = {
  number: PropTypes.number.isRequired,
  isHighlighted: PropTypes.bool,
  runtimeMode: PropTypes.bool.isRequired,
  executionStatus: PropTypes.string.isRequired,
  onSelectTask: PropTypes.func,
};

TaskConsolidateTips.defaultProps = {
  isHighlighted: false,
  onSelectTask: () => {},
};

export default TaskConsolidateTips;
